import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'appointment.id',
  })

  return {
    variables: { appointment_id },
    requestPolicy: 'network-only',
    pause: !appointment_id,
  }
}
